import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import firebase from "firebase/app";

/**
 * Route that requires the user to be authenticated AND have the admin custom claim.
 * Redirects to /SignIn if not authenticated, or /Home if not an admin.
 */
const AdminRoute = ({ component: Component, auth, ...rest }) => {
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    if (auth.uid) {
      const user = firebase.auth().currentUser;
      if (user) {
        user
          .getIdTokenResult()
          .then((idTokenResult) => {
            setIsAdmin(!!idTokenResult.claims.admin);
          })
          .catch(() => {
            setIsAdmin(false);
          });
      } else {
        setIsAdmin(false);
      }
    }
  }, [auth.uid]);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!auth.uid) return <Redirect to="/SignIn" />;
        if (isAdmin === null) return null; // Loading
        if (!isAdmin) return <Redirect to="/Home" />;
        return <Component {...props} />;
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  auth: state.firebase.auth,
});

export default compose(connect(mapStateToProps))(AdminRoute);
